import angular from 'angular';

angular.module('AaApp.Opp').constant('msrpTypes', {
    average: 1,
    inventory: 2
});
